import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrilldownNavComponent } from './drilldown-nav/drilldown-nav.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { NgxModalContainerComponent } from './ngx-modal-container/ngx-modal-container.component';
import { NgxCmLazyComponent } from './ngx-cm-lazy/ngx-cm-lazy.component';
import { NgxCmActivityIndicatorComponent } from './ngx-cm-activity-indicator/ngx-cm-activity-indicator.component';
import { NgxCmBlockCheckboxComponent } from './ngx-cm-block-checkbox/ngx-cm-block-checkbox.component';
import { NgxCmCheckboxComponent } from './ngx-cm-checkbox/ngx-cm-checkbox.component';
import { NgxCmCounterComponent } from './ngx-cm-counter/ngx-cm-counter.component';
import { NgxCmInputComponent } from './ngx-cm-input/ngx-cm-input.component';
import { NgxCmRangeSliderComponent } from './ngx-cm-range-slider/ngx-cm-range-slider.component';

@NgModule({
  declarations: [
    DrilldownNavComponent,
    DropdownComponent,
    DatepickerComponent,
    NgxModalContainerComponent,
    NgxCmLazyComponent,
    NgxCmActivityIndicatorComponent,
    NgxCmBlockCheckboxComponent,
    NgxCmCheckboxComponent,
    NgxCmCounterComponent,
    NgxCmInputComponent,
    NgxCmRangeSliderComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule.forRoot([])
  ],
  exports: [
    DrilldownNavComponent,
    DropdownComponent,
    DatepickerComponent,
    NgxModalContainerComponent,
    NgxCmLazyComponent,
    NgxCmActivityIndicatorComponent,
    NgxCmBlockCheckboxComponent,
    NgxCmCheckboxComponent,
    NgxCmCounterComponent,
    NgxCmInputComponent,
    NgxCmRangeSliderComponent
  ]
})
export class NgxCmComponentsModule { }
